"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormBailoutSchema = void 0;
const z = require("zod");
exports.FormBailoutSchema = z.object({
    bailedOut: z.boolean(),
    stepAtBailout: z.number().int().optional(),
});
//# sourceMappingURL=form.types.js.map